export default {
  name: "checkName",
  computed: {
    name: function () {
      return this.$store.state.form[this.dependsOn];
    },
  },
};
